// AppStatus identifies the availability of services.
export type AppStatus = 'enabled' | 'disabled' | 'disabled-consumer' | 'disabled-farmer'

// isValidAppStatus returns a type assertion to verify that an input is a valid status value.
export function isValidAppStatus(status: unknown): status is AppStatus {
  return status === 'enabled' || status === 'disabled' || status === 'disabled-consumer' || status === 'disabled-farmer'
}
